import { Factory } from 'fishery';
import type { ShopBrowseProductsQuery } from '../../queries/shopBrowseProducts';
type ShopBrowseResult = ShopBrowseProductsQuery['shopBrowseProducts']['results'][number];
const shopBrowseResultFactory = Factory.define<ShopBrowseResult>(({
  sequence
}) => ({
  __typename: 'ShopBrowseResult',
  skuId: `sku-${sequence}`,
  uniqueColorId: `color-${sequence}`,
  variant: {
    __typename: 'ShopProductVariant',
    sku: `sku-${sequence}`,
    url: `http://localhost:3000/product/sku-${sequence}`,
    color: {
      __typename: 'Color',
      name: 'Navy',
      swatch: {
        __typename: 'ColorSwatch',
        hex: '#001f5b',
        url: null
      }
    },
    image: {
      __typename: 'ShopMedia',
      baseUrl: 'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
      mediaPath: `/v1657136215/product-${sequence}.jpg`,
      altText: `Product ${sequence} front view`
    },
    price: {
      __typename: 'Money',
      value: 5400,
      currency: 'USD' as const
    },
    inventory: {
      __typename: 'ShopInventory',
      availability: 'AVAILABLE_STOCK' as const
    },
    shopProduct: {
      __typename: 'ShopProduct',
      name: `Pacific Short Sleeve Shirt ${sequence}`,
      brand: {
        __typename: 'Brand',
        name: 'Even Tide'
      }
    }
  },
  availableSizes: [{
    __typename: 'ShopBrowseAvailableSize',
    skuId: `sku-${sequence}-s`,
    sizeValue: 'S',
    inseam: null
  }, {
    __typename: 'ShopBrowseAvailableSize',
    skuId: `sku-${sequence}-m`,
    sizeValue: 'M',
    inseam: null
  }]
}));
export const shopBrowseProductsMock: ShopBrowseProductsQuery = {
  shopBrowseProducts: {
    __typename: 'ShopBrowseResults',
    totalCount: 3,
    page: 1,
    perPage: 24,
    personalized: false,
    results: shopBrowseResultFactory.buildList(3),
    facets: [{
      __typename: 'ShopBrowseFacet',
      name: 'color',
      buckets: [{
        __typename: 'ShopBrowseFacetBucket',
        key: 'navy',
        docCount: 2
      }, {
        __typename: 'ShopBrowseFacetBucket',
        key: 'black',
        docCount: 1
      }]
    }, {
      __typename: 'ShopBrowseFacet',
      name: 'size_value',
      buckets: [{
        __typename: 'ShopBrowseFacetBucket',
        key: 'S',
        docCount: 2
      }, {
        __typename: 'ShopBrowseFacetBucket',
        key: 'M',
        docCount: 3
      }]
    }, {
      __typename: 'ShopBrowseFacet',
      name: 'gender_intents',
      buckets: [{
        __typename: 'ShopBrowseFacetBucket',
        key: 'male',
        docCount: 10
      }, {
        __typename: 'ShopBrowseFacetBucket',
        key: 'female',
        docCount: 8
      }, {
        __typename: 'ShopBrowseFacetBucket',
        key: 'neutral',
        docCount: 4
      }]
    }, {
      __typename: 'ShopBrowseFacet',
      name: 'retail_price',
      buckets: [{
        __typename: 'ShopBrowseFacetBucket',
        key: '$0-$50',
        docCount: 5
      }, {
        __typename: 'ShopBrowseFacetBucket',
        key: '$50-$100',
        docCount: 8
      }, {
        __typename: 'ShopBrowseFacetBucket',
        key: '$100+',
        docCount: 3
      }]
    }],
    availableSorts: [{
      __typename: 'ShopBrowseSortOption',
      value: 'RELEVANCE',
      label: 'Relevance'
    }, {
      __typename: 'ShopBrowseSortOption',
      value: 'NEWEST',
      label: 'Newest'
    }]
  }
};
export { shopBrowseResultFactory };